import type { DocumentForm } from './document-form'
import type { TrainingDocument } from '~/gql/documents/documents'
import { useMutation } from '@apollo/client/react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { documentFilePath, GQL_ARCHIVE_TRAINING_DOCUMENT, GQL_UPDATE_TRAINING_DOCUMENT } from '~/gql/documents/documents'
import { downloadFromApi } from '~/helpers/files/download-from-api'

/** Modifier, archiver et télécharger un document (#326), avec leurs messages de retour. */
export function useDocumentActions(onDone: () => void) {
  const { t } = useTranslation()
  const [updateDocument, updated] = useMutation(GQL_UPDATE_TRAINING_DOCUMENT)
  const [archiveDocument, archived] = useMutation(GQL_ARCHIVE_TRAINING_DOCUMENT)

  const run = async (write: () => Promise<unknown>, success: string) => {
    try {
      await write()
      toast.success(t(success))
      onDone()
    } catch {
      toast.error(t('documents.saveFailed'))
    }
  }

  return {
    busy: updated.loading || archived.loading,
    update: (id: string, form: DocumentForm) => run(
      () => updateDocument({ variables: { input: { id, title: form.title, sessionId: form.sessionId || null, requiredBeforeStart: form.requiredBeforeStart } } }),
      'documents.saved',
    ),
    archive: (id: string) => run(() => archiveDocument({ variables: { id } }), 'documents.archived'),
    download: (document: TrainingDocument) => downloadFromApi(documentFilePath(document.id), document.fileName).catch(() => toast.error(t('documents.downloadFailed'))),
  }
}
